import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import logo from '../images/logo.png';
import RaceCountdown from './RaceCountdown';

export default function NavBar() {
    const navigate = useNavigate();
    const { currentUser, isAdmin, logout: contextLogout } = useUser();
    const [menuOpen, setMenuOpen] = useState(false);

    function closeMenu() {
        setMenuOpen(false);
    }

    function toggleMenu() {
        setMenuOpen((prev) => !prev);
    }

    function logout() {
        closeMenu();
        contextLogout();
        navigate('/login');
    }

    return (
        <>
            {/* Secondary Navigation - User & Login Actions */}
            <nav className="navbar navbar-dark bg-secondary secondary-navbar">
                <div className="container">
                    <div className="d-flex align-items-center w-100 justify-content-end gap-2">
                        {currentUser ? (
                            <>
                                <span className="user-badge-secondary">Signed in as <strong>{currentUser.display_name || currentUser.username}</strong></span>
                                <button className="btn btn-xs btn-outline-light" onClick={logout}>Logout</button>
                            </>
                        ) : (
                            <Link className="btn btn-xs btn-outline-light" to="/login" onClick={closeMenu}>Login</Link>
                        )}
                    </div>
                </div>
            </nav>

            {/* Primary Navigation */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark p-0">
                <div className="container">
                    <Link className="navbar-brand p-0" to="/" onClick={closeMenu}><img src={logo} alt="F1 Picks" className="navbar-logo" /></Link>
                    <RaceCountdown />
                    <button className="navbar-toggler" type="button" onClick={toggleMenu} aria-controls="navmenu" aria-expanded={menuOpen} aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className={`collapse navbar-collapse${menuOpen ? ' show' : ''}`} id="navmenu">
                        <ul className="navbar-nav ms-auto align-items-center">
                            {currentUser && localStorage.getItem('accessGranted') === 'true' ? (
                                <>
                                    <li className="nav-item"><NavLink className="nav-link" to="/picks" onClick={closeMenu}>Current Week</NavLink></li>
                                    <li className="nav-item dropdown">
                                        <button className="nav-link dropdown-toggle btn btn-link text-decoration-none" id="resultsDropdown" data-bs-toggle="dropdown" aria-expanded="false">Results</button>
                                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="resultsDropdown">
                                            <li><NavLink className="dropdown-item" to="/results" onClick={closeMenu}>Race Results</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/leaderboard" onClick={closeMenu}>Leaderboard</NavLink></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item"><NavLink className="nav-link" to="/scoring" onClick={closeMenu}>Scoring</NavLink></li>
                                    {isAdmin && <li className="nav-item"><NavLink className="nav-link" to="/admin" onClick={closeMenu}>Admin</NavLink></li>}
                                    {isAdmin && <li className="nav-item"><NavLink className="nav-link" to="/super-admin" onClick={closeMenu}>Super Admin</NavLink></li>}
                                </>
                            ) : null}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}
